<template>
  <div>
    <Head title="Paneli" />

    <div class="flex flex-wrap mx-2 mb-6 lg:mb-6">
      <h3 class="text-sm font-bold pr-6 w-full lg:w-full">Dërgesa
        <hr></h3>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2 w-full lg:w-1/6 bg-indigo-900 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link href="dergesat?status_ids[]=4">{{ this.ordersData.shipping }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në shpërndarje</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-yellow-700 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link href="dergesat?status_ids[]=6">{{ this.ordersData.pending }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në pritje</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2 w-full lg:w-1/6 bg-green-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link href="dergesat?status_ids[]=5&barazuar_me_baze=false">{{ this.ordersData.delivered }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Sukses</h1>
<!--        <h1 class="text-sm text-white">Total shitje: {{this.ordersData.delivered_sales}}</h1>-->
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-red-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link href="dergesat?status_ids[]=7&barazuar_me_baze=false">{{ this.ordersData.cancelled }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të anuluara</h1>
      </div>
    </div>

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  components: {
    Head, Link
  },
  layout: Layout,
  props: {
    ordersData: Object,
  },
}
</script>
